// import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import SectionCard from "./components/SectionCard";
import Achievement from "./components/Achievement";
import Footer from "./components/Footer";
import TestimonialsPage from "./Pages/Testimony"
import ImpactPage from "./Pages/Impact";
import EventsPage from "./Pages/Event";
import PartnersPage from "./Pages/Partners";
import PlacementDetails from "./Pages/placementdetail"
import Daap from "./Pages/DaapDashboard"
import ESJR from "./Pages/ESJRdashboard"
import Careercompass from "./Pages/Careercompass"
import Derejawebsite from "./Pages/Derejawebsite"
import Digitalskill from "./Pages/Digitalskill"
import Gallery from "./components/gallery";
import AboutSection from "./components/service";
import KnowledgeManagementPage from "./components/Hero"
import Knowledgehub from "./layouts/knowledgehub"
import KnowledgeLibrary from "./layouts/programassment"
import Knowledgeinsights from "./layouts/stakeholderinsights";
import DataAnalytics from "./layouts/dataanalytics";
import HealthInitiative from "./layouts/learnmore";
import TestimonialSection from "./components/EmployerTestimony";
import Trainingmaterial from "./layouts/trainingmaterial";
import Brochure from "./layouts/Brochure";
import Policystrategy from "./layouts/policystrategy";
function App() {
  return (
    <div className="App">
      <Header />

      <Routes>
       <Route
  path="/"
  element={
    <>
      <div id="about"><AboutSection /></div>
      <div id="achievements"><Achievement /></div>
      <div id="journey"><SectionCard /></div>
      <div id="youth"><TestimonialSection /></div>
      <div id="hub"><KnowledgeManagementPage /></div>
    </>
  }
/>
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/impact" element={<ImpactPage />} />
        <Route path="/events" element={<EventsPage/>} />
        <Route path="/partners" element={<PartnersPage/>} />
        <Route path="/placement" element={<PlacementDetails />}/>
        <Route path ="/daap" element={<Daap/>}/>
        <Route path ="/esjr" element={<ESJR/>}/>
        <Route path ="/careercompass" element={<Careercompass/>}/>
        <Route path = "/dls" element={<Digitalskill/>}/>
        <Route path = "/website" element={<Derejawebsite/>}/>
        <Route path = "/gallery" element={<Gallery/>}/>
        <Route path = "/knowledgehub" element={<Knowledgehub/>}/>
        <Route path = "/program" element={<KnowledgeLibrary/>}/>
        <Route path = "/stakeholderinsights" element={<Knowledgeinsights/>}/>
        <Route path = "/dataanalytics" element={<DataAnalytics/>}/>
        <Route path = "/trainingmaterial" element={<Trainingmaterial/>}/>
        <Route path = "/policy" element={<Policystrategy/>}/>
        <Route path ="/brochure" element={<Brochure/>}/>
        <Route path = "/learnmore" element={<HealthInitiative/>}/>
        
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
